module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-glasses-svgrepo-com.ca7d31b2.svg";